import '../sass/text-and-image-carousel.scss';

(() => {
    const swiperScript = document.querySelector('#ofg-education-swiper-js');
    const $blocks = document.querySelectorAll('.block.text-and-image-carousel');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $textCarousel = $block.querySelector('.text-and-image-carousel__text-carousel');
        const $mediaCarousel = $block.querySelector('.text-and-image-carousel__image-carousel');
        const $labels = $block.querySelectorAll('.text-and-image-carousel__highlights-label');
        const $carouselPagination = $block.querySelector('.text-and-image-carousel__pagination');
        const $textCarouselNavigationPrev = $block.querySelector('.text-and-image-carousel__text-carousel-navigation-prev');
        const $textCarouselNavigationNext = $block.querySelector('.text-and-image-carousel__text-carousel-navigation-next');
        
        const initCarousels = () => {
            let textCarousel, mediaCarousel;

            if ($mediaCarousel) {
                mediaCarousel = new Swiper($mediaCarousel, {
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                    allowTouchMove: false,
                    loop: true,
                });
            }

            if ($textCarousel) {
                textCarousel = new Swiper($textCarousel, {
                    pagination: false,
                    navigation: {
                        prevEl: $textCarouselNavigationPrev,
                        nextEl: $textCarouselNavigationNext,
                    },
                    loop: true,
                    keyboard: {
                        enabled: true,
                        onlyInViewport: true,
                    },
                    controller: {
                        control: mediaCarousel
                    }
                });
            }

            if ($labels) {
                $labels.forEach($label => {
                    $label.addEventListener('click', () => {
                        const { index } = $label.dataset;

                        $labels.forEach($label => {
                            $label.classList.remove('highlights__highlights-label--active');
                        });

                        $label.classList.add('highlights__highlights-label--active');

                        if (textCarousel) {
                            textCarousel?.slideTo(index);
                        }

                        if (mediaCarousel) {
                            mediaCarousel?.slideTo(index);
                        }
                    });
                })
            }
        };

        if (typeof Swiper !== 'undefined') {
            initCarousels();
        } else if (swiperScript) {
            swiperScript.addEventListener('load', () => {
                initCarousels();
            });
        } else {
            window.addEventListener('load', () => {
                const swiperScript = document.querySelector('#ofg-education-swiper-js');

                if (!swiperScript) return;

                initCarousels();
            });
        }
    });
})();
